import { createTRPCClient, httpBatchLink } from '@trpc/client';
import superjson from 'superjson';

import { isDesktop } from '@/const/version';
import type { ToolsRouter } from '@/server/routers/tools';

import { fetchWithDesktopRemoteRPC } from './helpers/desktop-remote-rpc-fetch';

export const toolsClient = createTRPCClient<ToolsRouter>({
  links: [
    httpBatchLink({
      fetch: isDesktop
        ? (input, init) => fetchWithDesktopRemoteRPC(input as string, init)
        : undefined,
      headers: async () => {
        return  {}
      },
      maxURLLength: 2083,
      transformer: superjson,
      url: '/api/trpc/tools',
    }),
  ],
});
